import { render, staticRenderFns } from "./message-file.vue?vue&type=template&id=52096db8&scoped=true"
import script from "./message-file.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-file.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-file.vue?vue&type=style&index=0&id=52096db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52096db8",
  null
  
)

export default component.exports